import { useQuery } from "@tanstack/react-query";
import { fetchScoringScalesForOrganization } from "../services/scoring_scales";

// The scoring scales a checklist heading may be assigned, for the logged-in
// user's organization. Cached for the session: the catalog is a handful of rows
// that only an admin ever changes.
const GetScoringScales = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const organizationId = user?.organizations?.[0]?.id;

  return useQuery({
    queryKey: ["scoring_scales", organizationId],
    queryFn: () => fetchScoringScalesForOrganization(organizationId),
    enabled: Boolean(organizationId),
    staleTime: 5 * 60 * 1000,
  });
};

export default GetScoringScales;
